import React, { ReactElement } from 'react';
import { Pagination } from 'slovlex-idsk-react-components';
import './aktualitaList.scss';
import { Heading } from 'idsk-react-components';
import AktualitaListPage from '../../../model/AktualitaListPage';
import AktualitaListGrid from './component/AktualitaListGrid';
import externalRoutes from '../../../routing/externalRoutes';
import RssLink from '../../../page/AktualitaListPage/RssLink';

interface Props {
  aktualitaPage: AktualitaListPage | null | undefined;
  pageNumberFromUrl: number;
}

const AktualitaList = ({
  aktualitaPage,
  pageNumberFromUrl,
}: Props): ReactElement => {
  if (!aktualitaPage) {
    return <></>;
  }

  if (aktualitaPage.total === 0) {
    return <p className="text-center">Nenašli sa žiadne záznamy.</p>;
  }

  return (
    <div className="aktualita-list">
      <Heading className="page-heading" size="xl">Aktuality</Heading>
      <RssLink to={externalRoutes.rss.aktuality} />
      <AktualitaListGrid aktualitaList={aktualitaPage?.results} />
      <Pagination
        number={pageNumberFromUrl}
        size={9}
        totalElements={aktualitaPage.total}
        hideTotal
      />
    </div>
  );
};

export default AktualitaList;
